import { AuthService } from './../../services/auth.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavbarService } from '../../services/navbar-service.service';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { AuthMessage } from '../../extra/auth-message';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit, OnDestroy {

  emailControl = new FormControl('', [Validators.required, Validators.email]);

  form = new FormGroup({
    email: this.emailControl,
  });

  hide = true;

  constructor(public navbarService: NavbarService, public authService: AuthService, public snackBar: MatSnackBar) { }

  ngOnInit() {
    this.navbarService.hide();
  }

  ngOnDestroy() {
    this.navbarService.show();
  }

  onFormSubmit() {
    const that = this;
    this.authService.resetPassword(this.form.value.email)
    .then(function () {
      that.openSnack('Instructions has been sent to ' + that.form.value.email, 'Thanks');
    })
    .catch(function (error) {
      console.log(error);
      that.openSnack(AuthMessage.convertMessage(error['code']), 'Ok');
    });
  }

  openSnack(message: string, action?: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    });
  }

  getErrorMessage() {
    return this.emailControl.hasError('required') ? 'You must enter a email' :
      this.emailControl.hasError('email') ? 'Not a valid email' :
        '';
  }

}



// WEBPACK FOOTER //
// /Users/magnustrandokken/Desktop/Magson/Web/Foko/foko-angular/src/app/ui/reset-password/reset-password.component.ts